import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MailIcon, LockIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
export function LoginPage() {
  const navigate = useNavigate();
  const {
    login
  } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      const success = await login(email, password);
      if (success) {
        navigate('/account');
      } else {
        setError('Invalid email or password');
      }
    } catch {
      setError('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4" data-id="element-1388" data-mp="1zjm2j4pk4lx0">
      <div className="w-full max-w-md" data-id="element-1389" data-mp="1kufviukh9rek">
        {/* Logo */}
        <div className="text-center mb-8" data-id="element-1390" data-mp="1krtqp2oz1q01">
          <Link to="/" className="inline-flex items-center gap-2" data-id="element-1391" data-mp="1ptssw98z6gve">
            <img src="https://cdn.magicpatterns.com/uploads/fRsBpVfPoCHsQawYgHjccg/ChatGPT_Image_Mar_6,_2026,_03_48_02_AM.png" alt="Gadgets Zone" className="h-12 w-auto object-contain" data-id="element-1392" data-mp="2dilgnifg1iex" />
            <span className="text-2xl font-bold text-gray-900" data-id="element-1393" data-mp="23k6029e1lrjo">
              Gadgets Zone
            </span>
          </Link>
        </div>

        <Card padding="lg" data-id="element-1394" data-mp="28i7hyqzqfktk">
          <h1 className="text-2xl font-bold text-gray-900 text-center mb-2" data-id="element-1395" data-mp="28he83h5h8f77">
            Welcome Back
          </h1>
          <p className="text-gray-600 text-center mb-6" data-id="element-1396" data-mp="s73gr6kk6nvt">
            Sign in to your account to continue
          </p>

          {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm" data-id="element-1397" data-mp="2zr906lzco2kf">
              {error}
            </div>}

          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1398" data-mp="2us64hs59f8p4">
            <Input label="Email Address" type="email" placeholder="your@email.com" value={email} onChange={e => setEmail(e.target.value)} leftIcon={<MailIcon className="w-5 h-5" data-id="element-1400" data-mp="2l1bhumo3q735" />} required data-id="element-1399" data-mp="2q0efvn5nzd1m" />

            <div className="relative" data-id="element-1401" data-mp="2g39ptc8p6xfj">
              <Input label="Password" type={showPassword ? 'text' : 'password'} placeholder="Enter your password" value={password} onChange={e => setPassword(e.target.value)} leftIcon={<LockIcon className="w-5 h-5" data-id="element-1403" data-mp="271a8eitrtrc2" />} rightIcon={<button type="button" onClick={() => setShowPassword(!showPassword)} className="text-gray-400 hover:text-gray-600" data-id="element-1404" data-mp="2746400i5c3xc">
                    {showPassword ? <EyeOffIcon className="w-5 h-5" data-id="element-1405" data-mp="5ayqmwm3fwe3" /> : <EyeIcon className="w-5 h-5" data-id="element-1406" data-mp="59xf6r1617vu" />}
                  </button>} required data-id="element-1402" data-mp="2g4bam8fimyag" />
            </div>

            <div className="flex items-center justify-between" data-id="element-1407" data-mp="cf16m8ak2gz">
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-1408" data-mp="7u3j4yps4yce">
                <input type="checkbox" className="w-4 h-4 text-primary-600 rounded" data-id="element-1409" data-mp="ctyaf3dgvpxz" />
                <span className="text-sm text-gray-600" data-id="element-1410" data-mp="hky3tyndnpvq">Remember me</span>
              </label>
              <Link to="/forgot-password" className="text-sm text-primary-600 hover:text-primary-700" data-id="element-1411" data-mp="mk1bzrynmc7x">
                Forgot password?
              </Link>
            </div>

            <Button type="submit" variant="primary" size="lg" fullWidth isLoading={isLoading} data-id="element-1412" data-mp="3l3hnicrzpnex">
              Sign In
            </Button>
          </form>

          <div className="mt-6 text-center" data-id="element-1413" data-mp="3uzl0kdodr6gn">
            <p className="text-gray-600" data-id="element-1414" data-mp="3uyjfrhhkb5lq">
              Don't have an account?{' '}
              <Link to="/register" className="text-primary-600 hover:text-primary-700 font-medium" data-id="element-1415" data-mp="3v4ezgbvh5m0">
                Create Account
              </Link>
            </p>
          </div>
        </Card>

        <p className="mt-6 text-center text-sm text-gray-500" data-id="element-1416" data-mp="1f75817frrg7k">
          Demo: Enter any email and password to login
        </p>
      </div>
    </div>;
}